import { render, staticRenderFns } from "./WelcomeAbout.vue?vue&type=template&id=961d5c1c&scoped=true"
import script from "./WelcomeAbout.vue?vue&type=script&lang=js"
export * from "./WelcomeAbout.vue?vue&type=script&lang=js"
import style0 from "./WelcomeAbout.vue?vue&type=style&index=0&id=961d5c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961d5c1c",
  null
  
)

export default component.exports